import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import * as actions from '../../redux/actions';
import { getTemplates, getAuthUser, getConfig } from '../../redux/selectors';

import {
    Fullwidth,
    CardHeader,
    PageHeader,
    ActionButtons,
    TemplateCardBody,
} from './Templates.stc';
import UserPopover from '../Dashboard/UserPopover';
import Popover from '../Popover';
import Button from '../Button';
import Image from '../Image';
import Card from '../Card';

const UserThumb = styled(Image)`
    width: 40px;
    height: 40px;
    object-fit: cover;
    border: 1px solid rgba(0, 0, 0, 0.1);
`;

function Templates() {
    const dispatch = useDispatch();
    const config = useSelector(getConfig);
    const user = useSelector(getAuthUser);
    const templates = useSelector(getTemplates);

    useEffect(() => {
        dispatch(actions.getTemplates());
    }, [dispatch]);

    const handleClickStartFromScratch = React.useCallback(() => {
        dispatch(actions.setBuildingId(null));
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <title>Start a Website</title>
            </Helmet>
            <Fullwidth>
                <div className="container">
                    <PageHeader>
                        <div>
                            <Link to="/dashboard/sites" className="fw-500">
                                <FontAwesomeIcon
                                    fixedWidth
                                    icon={['far', 'long-arrow-left']}
                                />{' '}
                                Back to Dashboard
                            </Link>
                        </div>
                        <div>
                            <Link to="/">
                                <Image
                                    width="90"
                                    alt="Dorik.io Single Page Website Builder"
                                    src="https://assets.dorik.io/5e443dca5619780040289e37/images/one-color-png_(1)_wdk58cni.png"
                                />
                            </Link>
                        </div>
                        <div>
                            {!user ? (
                                <Link to="/login" className="fw-500">
                                    Login
                                </Link>
                            ) : (
                                <Popover
                                    placement="bottomRight"
                                    content={<UserPopover user={user} />}
                                >
                                    <UserThumb
                                        type="circle"
                                        src={
                                            user.avatar ||
                                            '/assets/images/user-thumb.png'
                                        }
                                    />
                                </Popover>
                            )}
                        </div>
                    </PageHeader>
                </div>
            </Fullwidth>
            <div className="container">
                <CardHeader
                    style={{ background: '#ffffff' }}
                    className="spread-between"
                >
                    <h3>Choose your starting point</h3>
                    <div>
                        <Link to="/builder">
                            <Button
                                type="primary-alt"
                                onClick={handleClickStartFromScratch}
                            >
                                <FontAwesomeIcon
                                    fixedWidth
                                    icon={['far', 'border-all']}
                                />{' '}
                                Start from Scratch
                            </Button>
                        </Link>
                        {/* <Button type="primary-alt">
                            <FontAwesomeIcon
                                fixedWidth
                                icon={['far', 'upload']}
                            />{' '}
                            Import Template
                        </Button> */}
                    </div>
                </CardHeader>

                <div className="flex">
                    {!templates.length
                        ? null
                        : templates.map((tmp) => (
                              <div key={tmp.id} className="mb-30 col-lg-1/3">
                                  <Card
                                      //   coverHeight="220px"
                                      cover={
                                          tmp.thumbnail ||
                                          '/assets/images/image-placeholder.jpg'
                                      }
                                  >
                                      <TemplateCardBody>
                                          <h4 className="title">{tmp.title}</h4>
                                          <ActionButtons className="spread-between">
                                              <a
                                                  href={tmp.layout}
                                                  rel="noopener noreferrer"
                                                  className="fw-500"
                                                  target="_blank"
                                              >
                                                  Preview
                                              </a>
                                              <Link
                                                  className="fw-500"
                                                  to={`/builder?t=${tmp.id}`}
                                              >
                                                  <Button>
                                                      Select{' '}
                                                      <FontAwesomeIcon
                                                          fixedWidth
                                                          icon={[
                                                              'far',
                                                              'long-arrow-right',
                                                          ]}
                                                      />
                                                  </Button>
                                              </Link>
                                          </ActionButtons>
                                      </TemplateCardBody>
                                  </Card>
                              </div>
                          ))}
                </div>
            </div>
        </>
    );
}

export default Templates;
